import orderInstance from '../instance'
import orderModalLoginInstance from '../modalLoginInstance'

const updateUnpaidOrder = (orderId, data, hasModalLogin = false) => {
	return (hasModalLogin ? orderModalLoginInstance : orderInstance).put(`/orders/${orderId}/unpaid`, data)
}

export default updateUnpaidOrder
